const quizDifficulties = [
  {
    // value: "any",
    value: "",
    name: "Any Difficulty",
  },
  {
    value: "easy",
    name: "Easy",
  },
  {
    value: "medium",
    name: "Medium",
  },
  {
    value: "hard",
    name: "Hard",
  },
];

export default quizDifficulties;
